import { EMPTY_OBJECT } from '../../../constants/common'
import { QA_NAME_ICON_DEFAULT } from '../../../constants/qa'
import { getQaSelector } from '../../../utils/common'
import { ICON_COLOR, ICON_HEIGHT_24 } from '../Icon.constants'
import { useSvgMeta } from '../Icon.hooks'

import { getIconStyle } from './IconNG.utils'

import * as styles from './IconNG.module.css'

function IconNG({
  Icon,
  className = styles.iconContainer,
  color = ICON_COLOR.SecondaryTextColor,
  iconProps: {
    className: iconClassName = styles.Icon,
    ...iconProps
  } = EMPTY_OBJECT,
  qaContext = QA_NAME_ICON_DEFAULT,
  qaName,
  ref,
  size = ICON_HEIGHT_24,
  style,
  svgSize,
  ...restProps
}) {
  const { svgMeta, svgRef } = useSvgMeta({ size })

  const qaIconProps = getQaSelector({
    context: qaContext,
    value: qaName,
  })

  const iconStyle = getIconStyle({ color, size, style, svgMeta, svgSize })

  return (
    <div
      {...restProps}
      {...qaIconProps}
      className={className}
      ref={ref}
      style={iconStyle}
    >
      <Icon {...iconProps} className={iconClassName} ref={svgRef} />
    </div>
  )
}

export default IconNG
